export interface MapEvent {
    uuid: string;
    title: string;
    description?: string;
    eventTime: string;
    endTime?: string;
    validUntil?: string;
    occurrenceDate?: string;
    recurring: string;
    latitude: number;
    longitude: number;
    place?: string;
    address?: string;
    organizer?: string;
    link?: string;
    color: string;
    marker: string;
    areaCode?: string;
    pointUuid?: string;
    pointName?: string;
    pointMunicipality?: string;
    pointAddress?: string;
    pointContact?: string;
}

export interface MapPoint {
    uuid: string;
    name: string;
    municipality: string;
    address: string;
    latitude: number;
    longitude: number;
    contact?: string;
    areaCode?: string;
}

export interface MapArea {
    code: string;
    name: string;
    latitude: number;
    longitude: number;
    zoom: number;
}

export type TimeFilter = 'TODAY' | 'TOMORROW' | 'THIS_WEEK' | 'AT_DATE' | 'PLANNED' | 'LATEST';

export const DAY_NAMES = ['Понедељком', 'Уторком', 'Средом', 'Четвртком', 'Петком', 'Суботом', 'Недељом'];
